query GetEditionsThatWillSendImmediatelyWithDelayChange($editionId: ID!, $delay: TimespanInput) {
    dripEditionsThatWillSendImmediatelyWithDelayChange(editionId: $editionId, newDelay: $delay)
}
